import moment from "moment";

const GetFieldValue = (customField: {
    field_code: string|null,
    field_id: number,
    field_name: string
    field_type: string,
    values: Array<{
        value: string|number
    }>
}) => {

    switch (customField.field_type) {
        case "text":
            return customField.values[0].value;
        case "numeric":
            return parseFloat(<string>customField.values[0].value).toLocaleString()
        case "checkbox":
            return customField.values[0].value ? "Да" : "Нет";
        case "select":
            return customField.values[0].value;
        case "multiselect":
            return customField.values
                .map((value) => {
                    return value.value;
                })
                .join(", ");
        case "date":
            return moment(
                typeof customField.values[0].value === "number" ? customField.values[0].value * 1000 : customField.values[0].value
            ).format("DD.MM.YYYY");
        case "url":
            return customField.values[0].value;
        case "multitext":
            return customField.values[0].value;
        case "textarea":
            return customField.values[0].value;
        case "radiobutton":
            return customField.values[0].value;
        case "streetaddress":
            return customField.values[0].value;
        case "smart_address":
            return customField.values
                .map((value) => {
                    return value.value;
                })
                .join(", ");
        case "birthday":
            return moment(
                typeof customField.values[0].value === "number" ? customField.values[0].value * 1000 : customField.values[0].value
            ).format("DD.MM.YYYY");
        case "date_time":
            return moment(
                typeof customField.values[0].value === "number" ? customField.values[0].value * 1000 : customField.values[0].value
            ).format("DD.MM.YYYY HH:mm");
        default:
            return customField.values[0].value;
    }

}

export default GetFieldValue